import type { Organization } from '../organization';

export interface IAccount {
	id: string;
	name: string;
	organization: Organization;
}

export class Account implements IAccount {
	public id: string;
	public name: string;
	public organization: Organization;
	public constructor({ id, name, organization }: IAccount) {
		this.id = id;
		this.name = name;
		this.organization = organization;
	}
}
